<template>
  <v-card outlined>
    <v-card-text class="pa-2 pa-sm-4">
      <v-row dense align="center">
        <v-col cols="12" sm="4">
          <v-select
            v-model="params.keyId"
            :items="keys"
            dense
            hide-details
            clearable
            item-value="id"
            item-text="name"
            placeholder="Ключ"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <v-menu
            v-model="menuBegin"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="begin"
                v-bind="attrs"
                v-on="on"
                prepend-icon="mdi-calendar"
                label="Дата с"
                readonly
                clearable
                dense
                hide-details
              />
            </template>
            <v-date-picker v-model="begin" @input="menuBegin = false" />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="3">
          <v-menu
            v-model="menuEnd"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="end"
                v-bind="attrs"
                v-on="on"
                prepend-icon="mdi-calendar"
                label="Дата по"
                readonly
                clearable
                dense
                hide-details
              />
            </template>
            <v-date-picker v-model="end" @input="menuEnd = false" />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="auto">
          <v-btn icon @click="load">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="options"
      :footer-props="footerOptions"
      :server-items-length="total"
      item-key="id"
    >
      <template #item.key="{ item }">
        {{ item.key.name }}
      </template>
      <template #item.takenAt="{ item }">
        <keys-journal-item
          v-if="item.takenAt"
          :date="item.takenAt"
          :user="item.taker"
        />
        <span v-else>-</span>
      </template>
      <template #item.returnedAt="{ item }">
        <keys-journal-item
          v-if="item.returnedAt"
          :date="item.returnedAt"
          :user="item.returner"
        />
        <span v-else>-</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { withNotifications } from "@/utils/notifications";
import { getKeysJournal, getKeys } from "@/services/keys.service";
import KeysJournalItem from "./KeysJournalItem.vue";

export default {
  components: { KeysJournalItem },
  data() {
    return {
      headers: [
        { text: "Ключ", value: "key" },
        { text: "Взят", value: "takenAt" },
        { text: "Возвращен", value: "returnedAt" }
      ],
      items: [],
      item: {},
      total: 0,

      begin: new Date().toISOString().substring(0, 10),
      end: new Date().toISOString().substring(0, 10),
      options: { itemsPerPage: 25 },
      footerOptions: {
        itemsPerPageOptions: [10, 25, 50, 100]
      },

      loading: false,
      menuBegin: false,
      menuEnd: false,

      params: {},
      keys: []
    };
  },

  async mounted() {
    this.keys = await this.loadKeys();
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      immediate: true,
      deep: true
    },
    params: {
      handler() {
        this.load();
      },
      immediate: true,
      deep: true
    },

    begin() {
      this.load();
    },

    end() {
      this.load();
    }
  },

  methods: {
    async loadKeys() {
      this.loading = true;
      await withNotifications(async () => {
        this.keys = (await getKeys()).map(it => ({
          id: it.id,
          name: it.name
        }));
      });
      this.loading = false;
      return this.keys;
    },

    async load() {
      const { page = 1, itemsPerPage: size } = this.options;
      const { begin, end } = this;
      const { keyId } = this.params;

      this.loading = true;
      await withNotifications(async () => {
        const pageable = await getKeysJournal({
          keyId,
          page: page - 1,
          size,
          begin,
          end
        });
        this.total = pageable.totalElements;
        this.items = pageable.content;
      });
      this.loading = false;
    }
  }
};
</script>
